import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ChecklistEntregaCadastroForm, ChecklistEntregaCadastroSchema, defaultChecklistEntregaCadastroForm } from "../../../schemas/checklist_entrega_lista/checklistEntregaCadastro";
import { ChecklistEntrega } from "../../../../domain/models/checklist_entrega";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";

type props = {
    open: boolean,
    saving: boolean,
    loading: boolean,
    selectedChecklistEntrega?: ChecklistEntrega,

    handleOpenChangeHistory: (idTabela: number | null, tipoTabela: LogTipoTabela | null) => void
    onClose: () => void,
    onSubmit: (form: ChecklistEntregaCadastroForm) => void,

}

export const CadastroChecklistEntregaModal = ({
    open,
    saving,
    loading,
    selectedChecklistEntrega,

    handleOpenChangeHistory,
    onClose,
    onSubmit,

}: props) => {
    const hookFormCadastro = useForm<ChecklistEntregaCadastroForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultChecklistEntregaCadastroForm,
        resolver: zodResolver(ChecklistEntregaCadastroSchema),
    });

    useEffect(() => {
        if (selectedChecklistEntrega) {
            hookFormCadastro.setValue('idChecklistEntrega', selectedChecklistEntrega.idChecklistEntrega);
            hookFormCadastro.setValue('codigo', selectedChecklistEntrega.codigo ?? '');
            hookFormCadastro.setValue('descricao', selectedChecklistEntrega.descricao ?? '');
            hookFormCadastro.setValue('revisao', selectedChecklistEntrega.revisao ?? '');
            hookFormCadastro.setValue('campo1', selectedChecklistEntrega.campo1 ?? '');
            hookFormCadastro.setValue('campo2', selectedChecklistEntrega.campo2 ?? '');
            hookFormCadastro.setValue('campo3', selectedChecklistEntrega.campo3 ?? '');
            hookFormCadastro.setValue('campo4', selectedChecklistEntrega.campo4 ?? '');
            hookFormCadastro.setValue('ativo', selectedChecklistEntrega.ativo === true ? 1 : 0);
        } else {
            hookFormCadastro.reset(defaultChecklistEntregaCadastroForm);
        }
    }, [selectedChecklistEntrega, hookFormCadastro]);


    return (
        <BaseFormControlledModal
            open={open}
            saving={saving}
            loading={loading}
            title="Cadastro Checklist de Entrega"
            onClose={onClose}
            leftButtonSlot={
                selectedChecklistEntrega &&
                <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => handleOpenChangeHistory(selectedChecklistEntrega?.idChecklistEntrega ?? null, LogTipoTabela.CHECKLIST_ENTREGA)}>
                    <span className="text-xs">
                        Historico de alterações
                    </span>
                </PrimaryButton>}
            onSubmit={hookFormCadastro.handleSubmit(onSubmit)}>

            <FormContainer title={"Informações"} arrangement="fullRow">
                <>
                    <FormRadioGroupInput
                        name="ativo"
                        label="Status"
                        options={[
                            { id: 0, label: "Inativo" },
                            { id: 1, label: "Ativo" },
                        ]}
                        reactHookForm={hookFormCadastro}
                    />

                    <DefaultFormInput
                        name='codigo'
                        label='Código'
                        readOnly={false}
                        required={true}
                        reactHookForm={hookFormCadastro}

                    />

                    <DefaultFormInput
                        name='revisao'
                        label='Revisão'
                        readOnly={false}
                        required={false}
                        reactHookForm={hookFormCadastro}
                    />

                    <DefaultFormInput
                        name={'descricao'}
                        label="Descrição"
                        readOnly={false}
                        required={true}
                        multiline={true}
                        rows={5}
                        minRows={4}
                        maxRows={10}
                        reactHookForm={hookFormCadastro}
                    />


                    <DefaultFormInput
                        name={'campo1'}
                        label="Campo 1"
                        readOnly={false}
                        required={false}
                        reactHookForm={hookFormCadastro}
                    />

                    <DefaultFormInput
                        name={'campo2'}
                        label="Campo 2"
                        readOnly={false}
                        required={false}
                        reactHookForm={hookFormCadastro}
                    />
                    <DefaultFormInput
                        name={'campo3'}
                        label="Campo 3"
                        readOnly={false}
                        required={false}
                        reactHookForm={hookFormCadastro}
                    />
                    <DefaultFormInput
                        name={'campo4'}
                        label="Campo 4"
                        readOnly={false}
                        required={false}
                        reactHookForm={hookFormCadastro}
                    />

                </>
            </FormContainer>

        </BaseFormControlledModal>
    );
}